module.exports = __webpack_public_path__ + "static/media/books_demo.0ec0d1a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/books_demo.png
// module id = 93
// module chunks = 0